export default __webpack_public_path__ + "static/tickets-banner-ad11e4de4f5856fa55c543d50fdc5fcd.jpg";